<div class="flex flex-col gap-4">
  <div class="border-b border-gray-200 pb-2">
    <h2 class="text-lg font-bold text-gray-900" i18n="@@viewPharmacyDetailsTitle">Pharmacy Details</h2>
  </div>

  <div class="grid grid-cols-3 gap-x-4 gap-y-6">
    <div class="flex flex-col gap-1" [class.col-span-3]="(data().nickName?.length ?? 0) > 20">
      <label class="text-primary text-xs font-bold" i18n="@@viewPharmacyDetailsNickname">Pharmacy Nickname</label>
      <ng-container *ngTemplateOutlet="displayVal; context: { val: data().nickName }"></ng-container>
    </div>

    <div class="flex flex-col gap-1">
      <label class="text-primary text-xs font-bold" i18n="@@viewPharmacyDetailsOwner">
        Pharmacy Owner (Pharmacist Name)
      </label>
      <ng-container *ngTemplateOutlet="displayVal; context: { val: data().owner?.fullName }"></ng-container>
    </div>

    <div class="flex flex-col gap-1">
      <label class="text-primary text-xs font-bold" i18n="@@viewPharmacyDetailsOwnerMobile">
        Pharmacy Owner Phone Number
      </label>
      <span class="inline-block" dir="ltr" style="text-align: inherit">
        <ng-container *ngTemplateOutlet="displayVal; context: { val: data().pharmacyOwnerPhoneNumber }"></ng-container>
      </span>
    </div>

    <div class="flex flex-col gap-1">
      <label class="text-primary text-xs font-bold" i18n="@@viewPharmacyDetailsCommRegNo">
        Commercial Registration No.
      </label>
      <ng-container
        *ngTemplateOutlet="displayVal; context: { val: data().commercialRegistrationNumber }"></ng-container>
    </div>

    <div class="flex flex-col gap-1">
      <label class="text-primary text-xs font-bold" i18n="@@viewPharmacyDetailsTaxId">Tax Identification Number</label>
      <ng-container *ngTemplateOutlet="displayVal; context: { val: data().taxIdentificationNumber }"></ng-container>
    </div>

    <div class="flex flex-col gap-1">
      <label class="text-primary text-xs font-bold" i18n="@@viewPharmacyDetailsOwnerNationalId">
        Owner's National ID
      </label>
      <ng-container *ngTemplateOutlet="displayVal; context: { val: data().pharmacyOwnerNationalId }"></ng-container>
    </div>

    <div class="flex flex-col gap-1">
      <label class="text-primary text-xs font-bold" i18n="@@viewPharmacyDetailsSegment">Pharmacy Segment</label>
      <ng-container
        *ngTemplateOutlet="displayVal; context: { val: getTranslatedTitle(data().pharmacySegment) }"></ng-container>
    </div>

    <div class="flex flex-col gap-1">
      <label class="text-primary text-xs font-bold" i18n="@@viewPharmacyDetailsQuota">Quota</label>
      <span class="inline-block" dir="ltr" style="text-align: inherit">
        <ng-container
          *ngTemplateOutlet="
            displayVal;
            context: {
              val: data().pharmacyCredit
                ? (data().pharmacyCredit!.totalCredit | number: '1.0-2') +
                  ' \\ ' +
                  (data().pharmacyCredit!.remainingCredit | number: '1.0-2')
                : null,
            }
          "></ng-container>
      </span>
    </div>

    <div class="flex flex-col gap-1"></div>

    <div class="flex flex-col gap-1">
      <label class="text-primary text-xs font-bold" i18n="@@viewPharmacyDetailsGovernorate">Governorate</label>
      <ng-container
        *ngTemplateOutlet="displayVal; context: { val: getTranslatedTitle(data().governorate) }"></ng-container>
    </div>

    <div class="flex flex-col gap-1">
      <label class="text-primary text-xs font-bold" i18n="@@viewPharmacyDetailsCity">City</label>
      <ng-container *ngTemplateOutlet="displayVal; context: { val: getTranslatedTitle(data().city) }"></ng-container>
    </div>

    <div class="flex flex-col gap-1">
      <label class="text-primary text-xs font-bold" i18n="@@viewPharmacyDetailsRegion">Region</label>
      <ng-container *ngTemplateOutlet="displayVal; context: { val: getTranslatedTitle(data().region) }"></ng-container>
    </div>

    <div class="col-span-3 flex flex-col gap-1">
      <label class="text-primary text-xs font-bold" i18n="@@viewPharmacyDetailsAddress">Address</label>
      <ng-container *ngTemplateOutlet="displayVal; context: { val: data().address }"></ng-container>
    </div>

    <div class="col-span-3 mt-4 grid grid-cols-2 gap-5">
      <ng-container
        *ngTemplateOutlet="
          fileItem;
          context: { i18nId: 'fileCommReg', fid: data().commercialRegistrationFid }
        "></ng-container>
      <ng-container
        *ngTemplateOutlet="
          fileItem;
          context: { i18nId: 'fileTaxReg', fid: data().taxRegistrationCertificateFid }
        "></ng-container>
      <ng-container
        *ngTemplateOutlet="
          fileItem;
          context: { i18nId: 'fileContract', fid: data().pharmacyContractFid }
        "></ng-container>
      <ng-container
        *ngTemplateOutlet="fileItem; context: { i18nId: 'fileLicense', fid: data().pharmacyLicenseFid }"></ng-container>
      <ng-container
        *ngTemplateOutlet="
          fileItem;
          context: { i18nId: 'fileNationalId', fid: data().pharmacistNationalIdFid }
        "></ng-container>
    </div>

    @if (fileErrorMessage()) {
      <div class="col-span-3 mt-2 flex items-center gap-2 rounded-lg border border-red-300 bg-red-50 p-3">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
          class="flex-shrink-0 text-red-600">
          <circle cx="12" cy="12" r="10"></circle>
          <line x1="12" y1="8" x2="12" y2="12"></line>
          <line x1="12" y1="16" x2="12.01" y2="16"></line>
        </svg>
        <p class="text-sm text-red-800">{{ fileErrorMessage() }}</p>
      </div>
    }
  </div>
</div>

<ng-template #displayVal let-val="val">
  @if (val !== null && val !== undefined && val !== "") {
    <p class="text-sm font-medium break-words text-gray-900">{{ val }}</p>
  } @else {
    <p class="text-sm font-medium text-gray-400 italic" i18n="@@notAssigned">Not Assigned Yet</p>
  }
</ng-template>

<ng-template #fileItem let-i18nId="i18nId" let-fid="fid">
  <div class="bg-selected flex items-center justify-between rounded-lg p-3 shadow-sm" [class.opacity-50]="!fid">
    <div class="flex items-center gap-3">
      <div class="bg-gray flex h-8 w-8 items-center justify-center rounded text-white">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="18"
          height="18"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round">
          <path d="M13 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9z"></path>
          <polyline points="13 2 13 9 20 9"></polyline>
        </svg>
      </div>

      <div class="flex flex-col gap-0.5">
        <span class="text-xs font-bold text-gray-900">
          @switch (i18nId) {
            @case ("fileCommReg") {
              <span i18n="@@fileCommReg">Commercial Registration</span>
            }
            @case ("fileTaxReg") {
              <span i18n="@@fileTaxReg">Tax Registration Certificate</span>
            }
            @case ("fileContract") {
              <span i18n="@@fileContract">Pharmacy Contract</span>
            }
            @case ("fileLicense") {
              <span i18n="@@fileLicense">Pharmacy License</span>
            }
            @case ("fileNationalId") {
              <span i18n="@@fileNationalId">National ID Card</span>
            }
          }
        </span>
        @if (fid && fileTypes()[fid]) {
          <span class="text-[10px] font-medium text-gray-400 uppercase">
            {{ fileTypes()[fid] === "pdf" ? "PDF" : "IMG" }}
          </span>
        }
      </div>
    </div>

    @if (fid) {
      <div class="flex items-center gap-3 text-gray-500">
        @if (fileTypes()[fid] === "image") {
          <button (click)="viewFile(fid)" class="hover-text-primary cursor-pointer transition-colors">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="18"
              height="18"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round">
              <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
              <circle cx="12" cy="12" r="3"></circle>
            </svg>
          </button>
        }
        <button (click)="downloadFile(fid)" class="hover-text-primary cursor-pointer transition-colors">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="18"
            height="18"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round">
            <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
            <polyline points="7 10 12 15 17 10"></polyline>
            <line x1="12" y1="15" x2="12" y2="3"></line>
          </svg>
        </button>
      </div>
    } @else {
      <span class="text-xs text-gray-400 italic" i18n="@@fileNotAvailable">Not Available</span>
    }
  </div>
</ng-template>

@if (previewImageUrl()) {
  <div
    class="fixed inset-0 z-[100] flex items-center justify-center bg-black/80 backdrop-blur-sm"
    (click)="closePreview()">
    <div class="relative max-h-[90vh] max-w-[90vw]" (click)="$event.stopPropagation()">
      <button
        (click)="closePreview()"
        class="absolute -top-10 right-0 cursor-pointer text-white transition-colors hover:text-gray-300">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="32"
          height="32"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round">
          <line x1="18" y1="6" x2="6" y2="18"></line>
          <line x1="6" y1="6" x2="18" y2="18"></line>
        </svg>
      </button>
      <img [src]="previewImageUrl()" class="max-h-[85vh] rounded-lg object-contain shadow-2xl" alt="File Preview" />
    </div>
  </div>
}

@if (isLoadingFile()) {
  <div class="fixed inset-0 z-[101] flex items-center justify-center bg-white/50">
    <div class="border-primary h-10 w-10 animate-spin rounded-full border-4 border-t-transparent"></div>
  </div>
}
